/* eslint-disable react-refresh/only-export-components -- exports hook alongside provider */
import React, { createContext, useContext, useState } from 'react';

interface UIContextType {
  isAIAssistantOpen: boolean;
  setIsAIAssistantOpen: (open: boolean) => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

export function UIProvider({ children }: { children: React.ReactNode }) {
  const [isAIAssistantOpen, setIsAIAssistantOpen] = useState(false);

  return (
    <UIContext.Provider value={{ isAIAssistantOpen, setIsAIAssistantOpen }}>
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
